import { setupI18n } from "@lingui/core";
import { store } from "../store";
import "url-search-params-polyfill";

export const getDefaultLocale = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has("lang") ? searchParams.get("lang") : "fr";
};

export const getCatalog = locale =>
  require(`@lingui/loader!../locales/${locale}/messages.json`);

const getCurrentLocale = () =>
  store && store.getState().locale.language
    ? store.getState().locale.language
    : getDefaultLocale();

const _translators = {};
export const translator = () => {
  const currentLocale = getCurrentLocale();
  if (!_translators[currentLocale]) {
    _translators[currentLocale] = setupI18n({
      language: currentLocale,
      catalogs: { [currentLocale]: getCatalog(currentLocale) }
    });
  }

  return _translators[currentLocale];
};
